import { supabase } from '../supabaseClient';

// Missing employees to import (excluding may.2023 and nov.2021)
const MISSING_EMPLOYEES = [
  { employee_number: 'shirley', employee_name: 'Shirley Zhou' },
  { employee_number: 'irene', employee_name: 'iRENE Lin' },
  { employee_number: 'yahui', employee_name: 'YaHui Tian' },
  { employee_number: 'jamie', employee_name: 'Jamie Wong' },
  { employee_number: 'ayi', employee_name: 'Qiu Yi Liu' },
  { employee_number: 'cheng', employee_name: 'Cheng Yang' },
  { employee_number: 'sue', employee_name: 'Sue Feng' },
  { employee_number: 'amber', employee_name: 'XinYi Amber Wang' },
  { employee_number: 'chloe', employee_name: 'Chloe Cao' },
  { employee_number: 'mary', employee_name: 'Yali Mai' },
  { employee_number: 'yvonne', employee_name: 'Yufang Meng-Yvonne' },
  { employee_number: 'nico', employee_name: 'Fuh Mei Tzong-Nico' },
  { employee_number: 'jason', employee_name: 'ZhiJing Chi(Jason)' },
  { employee_number: 'tiffany', employee_name: 'Tiffany Koo' },
  { employee_number: 'liz', employee_name: 'Liz Ng' }
];

export async function importMissingEmployeesToPeriod2513() {
  try {
    console.log('📊 Starting Import of Missing Employees for Payroll Period 2513...');
    console.log(`👥 Employees to import: ${MISSING_EMPLOYEES.length}`);
    
    // Check existing employees first
    console.log('🔍 Checking existing employees in database...');
    const { data: existingEmployees, error: fetchError } = await supabase
      .from('payroll_summary')
      .select('employee_number, employee_name, company')
      .eq('payroll_number', 2513);
    
    if (fetchError) {
      console.error('❌ Error fetching existing employees:', fetchError);
      throw fetchError;
    }
    
    console.log(`💾 Found ${existingEmployees.length} existing employees in database for period 2513`);
    
    // Filter out employees that already exist
    const employeesToImport = [];
    
    MISSING_EMPLOYEES.forEach(employee => {
      const existsInDB = existingEmployees.find(existing => 
        existing.employee_number.toLowerCase() === employee.employee_number.toLowerCase()
      );
      
      if (existsInDB) {
        console.log(`⚠️  Employee ${employee.employee_number} already exists, skipping`);
        return;
      }
      
      // Create base record template
      const baseRecord = {
        employee_number: employee.employee_number,
        employee_name: employee.employee_name,
        payroll_number: 2513,
        payroll_period: '060925-062225',
        total_pay: 0, // Will need to be updated with actual data
        total_hours: 0,
        employee_deductions: 0,
        employee_taxes: 0,
        // Default timesheet values (zeros for now)
        week1_mon: 0, week1_tue: 0, week1_wed: 0, week1_thu: 0, 
        week1_fri: 0, week1_sat: 0, week1_sun: 0,
        week2_mon: 0, week2_tue: 0, week2_wed: 0, week2_thu: 0, 
        week2_fri: 0, week2_sat: 0, week2_sun: 0,
        pto_hp: 0,
        sick_leave: 0,
        lunch: 0
      };
      
      // Add records for both companies
      employeesToImport.push({
        ...baseRecord,
        company: 'KF'
      });
      
      employeesToImport.push({
        ...baseRecord,
        company: 'KOO'
      });
      
      console.log(`✅ Prepared ${employee.employee_number} (${employee.employee_name}) for import`);
    });
    
    if (employeesToImport.length === 0) {
      console.log('✅ No new employees to import - all already exist');
      return { success: true, imported: 0, message: 'All employees already exist' };
    }
    
    console.log(`📦 Prepared ${employeesToImport.length} records for import (${employeesToImport.length / 2} employees × 2 companies)`);
    
    // Import to database
    console.log('🚀 Importing records to database...');
    const { data: insertedData, error: insertError } = await supabase
      .from('payroll_summary')
      .insert(employeesToImport)
      .select();
    
    if (insertError) {
      console.error('❌ Error importing records:', insertError);
      throw insertError;
    }
    
    console.log(`✅ SUCCESS! Imported ${insertedData.length} records`);
    
    // Verify the import
    const { data: verifyData, error: verifyError } = await supabase
      .from('payroll_summary')
      .select('employee_number, employee_name, company')
      .eq('payroll_number', 2513)
      .order('employee_name');
    
    if (verifyError) {
      console.error('❌ Error verifying import:', verifyError);
      throw verifyError;
    }
    
    const uniqueEmployees = [...new Set(verifyData.map(r => r.employee_number))].length;
    console.log(`📊 FINAL COUNT: ${verifyData.length} total records, ${uniqueEmployees} unique employees in payroll period 2513`);
    
    const importedEmployeeNumbers = [...new Set(employeesToImport.map(r => r.employee_number))];
    console.log('✅ IMPORTED EMPLOYEES:');
    importedEmployeeNumbers.forEach(empNum => {
      const emp = MISSING_EMPLOYEES.find(e => e.employee_number === empNum);
      console.log(`  • ${empNum} (${emp.employee_name})`);
    });
    
    return {
      success: true,
      imported: insertedData.length,
      employees: importedEmployeeNumbers.length,
      totalEmployees: uniqueEmployees,
      message: `Successfully imported ${importedEmployeeNumbers.length} employees with ${insertedData.length} total records`
    };
    
  } catch (error) {
    console.error('❌ Fatal error during import:', error);
    return {
      success: false,
      error: error.message,
      message: 'Import failed - see console for details'
    };
  }
}

export default { importMissingEmployeesToPeriod2513 };